import { MatDialogConfig } from '@angular/material/dialog';

/**
 * Modal props with optional modal name
 */
interface ModalPropsDefault {
    modalName?: string;
}

/**
 * Modal options interface
 */
export interface ModalOptions<T = any> {
    cmpType: any;
    fixed?: boolean; // if true - background is not scrollable and have a backdrop
    props?: T & ModalPropsDefault;
    modalOptions?: MatDialogConfig;
}

/**
 * Modal state interface
 */
export interface ModalState {
    /**
     * Whether modal is open or not
     */
    open: boolean;
    /**
     * Component to open
     */
    cmpType?: any;
    /**
     * Title of the modal
     */
    title?: string;
    /**
     * Latest result passed back when the modal closed (if any)
     */
    latestResult?: any;
}

/**
 * Initial modal state
 */
export const initialModalState: ModalState = {
    open: false,
};